import { generateMetaTags } from 'helpers';
import LegalPages from 'Layout/LegalPages';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    fetchTermsAndConditions,
    selectTermsAndConditions,
    selectTermsAndConditionsIsLoading,
    selectTermsAndConditionsTags,
} from 'store/slices/LegalSlice';

const TermsAndConditions = () => {
    const dispatch = useDispatch();
    const isLoading = useSelector(selectTermsAndConditionsIsLoading);
    const data = useSelector(selectTermsAndConditions);

    const termsAndConditionsTags = useSelector(selectTermsAndConditionsTags);
    const metaTags = generateMetaTags(termsAndConditionsTags?.tags, 'meta');

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchTermsAndConditions());
    }, [dispatch]);

    const { blocks, title, updatedAt } = data;

    return <LegalPages loading={isLoading} title={title} blocks={blocks} updatedAt={updatedAt} metaTags={metaTags} />;
};

export default TermsAndConditions;
